import { useLayoutEffect, useState } from "react";

export default function useOmsModalHeight(paneLimit = 480) {
  const [content, setContent] = useState<HTMLDivElement | null>(null);
  const [title, setTitle] = useState<HTMLSpanElement | null>(null);
  const [footerContent, setFooterContent] = useState<HTMLDivElement | null>(
    null
  );
  const [height, setHeight] = useState<number>();
  const [pane, setPane] = useState<HTMLDivElement | null>(null);
  const [paneMaxHeight, setPaneMaxHeight] = useState<number>();
  useLayoutEffect(() => {
    if (!content || !title || !footerContent) return undefined;
    let frame = content.parentElement;
    while (frame && (!frame.contains(title) || !frame.contains(footerContent)))
      frame = frame.parentElement;
    if (!frame) return undefined;
    let header: HTMLElement = title;
    while (header.parentElement && header.parentElement !== frame)
      header = header.parentElement;
    const footer = footerContent.parentElement;
    if (!footer) return undefined;
    const padding = Math.max(
      0,
      frame.getBoundingClientRect().height -
        content.getBoundingClientRect().height -
        header.getBoundingClientRect().height -
        footer.getBoundingClientRect().height
    );
    const update = () => {
      // Measure the native slots so compact forms keep their natural height.
      const chrome =
        header.getBoundingClientRect().height +
        footer.getBoundingClientRect().height +
        padding;
      const available = Math.max(160, window.innerHeight - 32);
      if (pane) {
        const outsidePane =
          content.getBoundingClientRect().height -
          pane.getBoundingClientRect().height;
        setPaneMaxHeight(
          Math.max(180, Math.min(paneLimit, available - chrome - outsidePane))
        );
      }
      setHeight(
        content.getBoundingClientRect().height + chrome > available
          ? available
          : undefined
      );
    };
    const observer =
      typeof ResizeObserver === "undefined"
        ? undefined
        : new ResizeObserver(update);
    [content, header, footer, pane].forEach((element) => {
      if (element) observer?.observe(element);
    });
    update();
    window.addEventListener("resize", update);
    return () => {
      observer?.disconnect();
      window.removeEventListener("resize", update);
    };
  }, [content, title, footerContent, pane, paneLimit]);
  // The native modal portal mounts its slots after the parent layout effect.
  return {
    height,
    contentRef: setContent,
    titleRef: setTitle,
    footerRef: setFooterContent,
    paneRef: setPane,
    paneMaxHeight,
  };
}
